import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#fff\" d=\"M0 .5h48v48H0z\"></path><rect width=\"7\" height=\"22\" x=\"2.333\" y=\"13.5\" stroke=\"#475467\" stroke-width=\"2\" rx=\"1\"></rect><rect width=\"7\" height=\"22\" x=\"14.334\" y=\"13.5\" stroke=\"#475467\" stroke-width=\"2\" rx=\"1\"></rect><rect width=\"7\" height=\"22\" x=\"26.334\" y=\"13.5\" stroke=\"#475467\" stroke-width=\"2\" rx=\"1\"></rect><rect width=\"7\" height=\"22\" x=\"38.334\" y=\"13.5\" stroke=\"#475467\" stroke-width=\"2\" rx=\"1\"></rect>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
export default { render: render }